import { AlertCircle, AlertTriangle, CheckCircle2, Info } from "lucide-react";
import type { JSX } from "react";
import { Alert, AlertDescription, AlertTitle } from "../alert";

type AlertVariant = "default" | "info" | "destructive" | "success" | "warning";

interface AlertMessageProps {
  variant?: "default" | "info" | "destructive" | "success" | "warning";
  title: string;
  description: string;
}

const iconMap: Record<AlertVariant, JSX.Element> = {
  default: <Info className="h-4 w-4" />,
  info: <AlertCircle className="h-4 w-4 text-info!" />,
  destructive: <AlertCircle className="h-4 w-4 text-error" />,
  success: <CheckCircle2 className="h-4 w-4 text-success" />,
  warning: <AlertTriangle className="h-4 w-4 text-warning" />,
};

export function AlertMessage({
  variant = "default",
  title,
  description,
}: AlertMessageProps): JSX.Element {
  return (
    <Alert variant={variant}>
      {iconMap[variant]}
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{description}</AlertDescription>
    </Alert>
  );
}
